import GuestHeader from '@/components/GuestHeader';
import DiscoveryPreview from '@/components/DiscoveryPreview';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Utensils, Compass, Map, Sparkles, Car, Heart, Moon, ShoppingBag, Leaf, ArrowUpRight } from 'lucide-react';
import { analytics } from '@/utils/analytics';
import '@/homepage.css';
const API_URL = '';
const HERO_IMAGE = "https://images.unsplash.com/photo-1716872491340-4626a22c582d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxHb2xkJTIwQ29hc3QlMjBBdXN0cmFsaWElMjBiZWFjaCUyMHN1bnNldCUyMHNreWxpbmV8ZW58MHx8fHwxNzczMjgxMDMyfDA&ixlib=rb-4.1.0&q=85&w=1200";
const iconMap = { Utensils, Compass, Map, Sparkles, Car, Heart, Moon, ShoppingBag, Leaf };
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
function Collection({title, businesses, list=false}) {
  if (!businesses.length) return null;
  return <section className="dq-collection" aria-label={title}>
    <div className="dq-collection-heading"><h2>{title}</h2><Link to="/category/all">View all <ArrowUpRight aria-hidden="true" size={16}/></Link></div>
    <div className={list ? 'dq-preview-list' : 'dq-preview-rail'}>{businesses.map(b => <DiscoveryPreview key={b.business_id} business={b} list={list}/>)}</div>
  </section>;
}
export default function HomePage() {
  const [categories, setCategories] = useState([]);
  const [trendingBusinesses, setTrendingBusinesses] = useState([]);
  const [topRatedBusinesses, setTopRatedBusinesses] = useState([]);
  const [popularBusinesses, setPopularBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    analytics.trackPageView('home');
    const fetchData = async () => {
      try {
        const catResponse = await fetch(`${API_URL}/api/public/categories`);
        if (catResponse.ok) setCategories(await catResponse.json());

        const bizResponse = await fetch(`${API_URL}/api/public/businesses`);
        if (bizResponse.ok) {
          const bizData = await bizResponse.json();
          const featured = bizData.filter(b => b.is_featured);
          const nonFeatured = bizData.filter(b => !b.is_featured);
          setTrendingBusinesses(shuffleArray([...bizData]).slice(0, 6));
          setTopRatedBusinesses(shuffleArray([...bizData]).slice(0, 6));
          setPopularBusinesses([...shuffleArray(featured), ...shuffleArray(nonFeatured)].slice(0, 4));
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return <div className="dq-home" data-testid="home-page">
    <GuestHeader />
    <main className="dq-home-main">
      <section className="dq-discovery-intro">
        <p className="dq-eyebrow">YOUR GOLD COAST, DISCOVERED.</p>
        <h1>What would you<br/>like to do?</h1>
        <p className="dq-intro-copy">Good places. Local experiences. All within reach.</p>
        {loading ? <p role="status" className="dq-loading">Finding places to explore…</p> :
        <nav className="dq-categories" aria-label="Discover by category">{categories.slice(0,8).map(category => {
          const Icon = iconMap[category.icon] || Compass;
          return <Link key={category.category_id} to={`/category/${category.slug}`} data-testid={`category-${category.slug}`}><Icon aria-hidden="true" size={21} strokeWidth={1.5}/><span>{category.name}</span><ArrowUpRight className="dq-category-arrow" aria-hidden="true" size={14}/></Link>;
        })}</nav>}
      </section>
      <Link to="/category/all" className="dq-destination" data-testid="hero-discovery-card">
        <img src={HERO_IMAGE} alt="Gold Coast skyline at sunset" loading="eager"/>
        <div><span className="dq-eyebrow">A PLACE WORTH EXPLORING</span><h2>A little local knowledge.<br/>A better day out.</h2><span className="dq-destination-link">Explore the Gold Coast <ArrowUpRight aria-hidden="true" size={18}/></span></div>
      </Link>
      <Collection title="Places to discover" businesses={trendingBusinesses}/>
      <Collection title="More to explore" businesses={topRatedBusinesses}/>
      <Collection title="In the spotlight" businesses={popularBusinesses} list/>
      {!loading && !trendingBusinesses.length && <p className="dq-loading" role="status">Places are unavailable right now. Please try again shortly.</p>}
      <Link className="dq-map-link" to="/map"><span>Find your next stop.<small>Explore places on the map</small></span><ArrowUpRight aria-hidden="true"/></Link>
    </main>
  </div>;
}
